import { useContext } from 'react';
import { OperationalDashboardAccessContext } from './OperationalDashboardAccessContext';

/** `{ hasAccess, loading }` for the signed-in account. */
export function useOperationalDashboardAccess() {
    return useContext(OperationalDashboardAccessContext);
}

export default useOperationalDashboardAccess;
